import React from "react";
import { Busy } from "../presentational/busy";
import { SelectedCharities } from "../presentational/selectedCharities";
import { Card } from "../presentational/card";
import { CategoryNavigation } from "../presentational/categoryNavigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/pro-light-svg-icons/faArrowCircleLeft";
import GoogleFontLoader from "react-google-font-loader";
import ReactGA from "react-ga";
import styles from "../../styles/panels/featuredCharitySelector.css";
import * as utilities from "../../middleware/utilities";

export class FeaturedCharitySelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      busy: false,
      featuredCharities: [],
      charity: null,
      hoverPosition: { top: 0, left: 0 },
    };
  }

  componentDidMount() {
    ReactGA.pageview("/Spend/FeaturedCharitySelector");
    this.getCharities();
    utilities
      .isCodeValid(this.props.code)
      .then((valid) => {
        if (!valid) {
          this.props.onCodeError();
        }
      })
      .catch(() => {
        this.props.onCodeError();
      });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedCategory.id != this.props.selectedCategory.id) {
      this.getCharities();
    }
  }
  getCharities() {
    this.setState({ busy: true }, () => {
      if (this.props.selectedCategory) {
        utilities
          .getFeaturedCharities(this.props.selectedCategory.id)
          .then((featuredCharities) => {
            this.setState({
              busy: false,
              featuredCharities: featuredCharities.charities.filter(
                (charity, index, array) => {
                  return (
                    charity.ein &&
                    charity.ein.length > 0 &&
                    index ==
                      array.findIndex((item) => {
                        return item.ein == charity.ein;
                      })
                  );
                }
              ),
            });
          });
      }
    });
  }
  renderBusy() {
    return (
      <div className={styles.charities}>
        <div className={styles.busy}>
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
  renderNavigation() {
    let category = { ...this.props.selectedCategory };
    return (
      <div className={styles.navigation}>
        <div className={styles.message}>
          <div
            className={styles.icon}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Back Button",
                label: "/Spend/FeaturedCharitySelector",
              });
              this.props.onBack();
            }}
          >
            <FontAwesomeIcon icon={faArrowCircleLeft} />
          </div>
          {category.title}
        </div>
      </div>
    );
  }
  renderCallout() {
    return (
      <div className={styles.callout}>
        <div
          className={styles.slide}
          style={{
            top: this.state.hoverPosition.top,
            left: this.state.hoverPosition.left,
          }}
        >
          <div className={styles.beak} />
          <div className={styles.details}>
            <h2>{this.state.charity.name}</h2>
            <div>{this.state.charity.description}</div>
          </div>
        </div>
      </div>
    );
  }
  renderCharities() {
    let selectedEINs = this.props.selectedCharities.map((charity) => {
      return charity.ein;
    });
    return (
      <div className={styles.charities}>
        {this.state.featuredCharities.map((charity) => {
          return (
            <div
              className={styles.charity}
              key={charity.ein}
              onClick={() => {
                ReactGA.event({
                  category: "User Action",
                  action: "Clicked Open Charity " + charity.ein,
                  label: "/Spend/FeaturedCharitySelector",
                });
                this.props.onViewCharity(charity);
              }}
            >
              <div className={styles.imageSpace}>
                <img
                  src={charity.image}
                  title={charity.title}
                  className={styles.image}
                  onMouseEnter={(event) => {
                    let boundingClientRect =
                      event.target.getBoundingClientRect();
                    this.setState({
                      charity: charity,
                      hoverPosition: {
                        top: boundingClientRect.top,
                        left: boundingClientRect.left + event.target.width,
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    this.setState({
                      charity: null,
                      hoverPosition: { top: 0, left: 0 },
                    });
                  }}
                />
              </div>
              <div className={styles.label}>{charity.name}</div>
              <div className={styles.commands}>
                {selectedEINs.indexOf(charity.ein) == -1 ? (
                  this.props.additionalCharityCount >=
                  this.props.selectedCharities.length ? (
                    <button
                      className={styles.button + " " + styles.select}
                      onClick={(event) => {
                        event.stopPropagation();
                        ReactGA.event({
                          category: "User Action",
                          action: "Clicked Select Charity",
                          label: "/Spend/FeaturedCharitySelector",
                        });
                        this.props.onSelectCharity(charity);
                      }}
                    >
                      {this.props.dictionary.featured_charity_selector_select}
                    </button>
                  ) : (
                    <button className={styles.button + " " + styles.disabled}>
                      {this.props.dictionary.featured_charity_selector_disabled}
                    </button>
                  )
                ) : (
                  <button
                    className={styles.button + " " + styles.unselect}
                    onClick={(event) => {
                      event.stopPropagation();
                      ReactGA.event({
                        category: "User Action",
                        action: "Clicked Remove Charity",
                        label: "/Spend/FeaturedCharitySelector",
                      });
                      this.props.onRemoveCharity(charity.ein);
                    }}
                  >
                    {this.props.dictionary.featured_charity_selector_unselect}
                  </button>
                )}
              </div>
            </div>
          );
        })}
        {this.state.charity ? this.renderCallout() : null}
      </div>
    );
  }
  renderAside() {
    return (
      <div className={styles.aside}>
        <SelectedCharities
          selectedCharities={this.props.selectedCharities}
          dictionary={this.props.dictionary}
          additionalCharityCount={this.props.additionalCharityCount}
          collapse={this.props.collapseSelectedCharities}
          donation={this.props.donation}
          onToggleCollapse={() => {
            this.props.onToggleCollapseSelectedCharities();
          }}
          onRemoveCharity={(ein) => {
            this.props.onRemoveCharity(ein);
          }}
          onContinue={() => {
            this.props.onContinue();
          }}
        />
        <Card
          src={this.props.donation.image}
          alt={this.props.donation.amount}
        />
      </div>
    );
  }
  render() {
    if (this.props.busy) {
      return <Busy />;
    } else {
      let category = { ...this.props.selectedCategory };
      return (
        <div className={styles.main}>
          <GoogleFontLoader
            fonts={[
              {
                font: "Source Sans Pro",
                weights: ["Light"],
              },
            ]}
          />
          {this.renderNavigation()}
          <div className={styles.content}>
            <div className={styles.categoryDetails}>
              <div className={styles.categoryLeft}>
                <img alt={category.title} src={category.image} />
              </div>
              <div className={styles.categoryRight}>
                <div className={styles.quote}>{category.quote}</div>
                <div className={styles.quotee}>{category.quotee}</div>
              </div>
            </div>
            {this.state.busy ? this.renderBusy() : this.renderCharities()}
            <CategoryNavigation
              dictionary={this.props.dictionary}
              categories={this.props.categories}
              selectedCategory={this.props.selectedCategory}
              onSelectCategory={(category) => {
                this.props.onSelectCategory(category);
              }}
              onSearchAll={() => {
                this.props.onSearchAll();
              }}
            />
          </div>
          {this.renderAside()}
        </div>
      );
    }
  }
}
